import client from './index'

const getData = (data) => client['api'].get(`studysession`, {params: data})
const store = (data) => client['api'].post(`studysession`, data)
const update = (data,id) => client['api'].patch(`studysession/${id}`, data)
const destroy = (id) => client['api'].delete(`studysession/${id}`)
const getAllSessions = () => client['api'].get(`getAllSessions`)

export {
    getData,
    store,
    update,
    destroy,
    getAllSessions
}